import { render, staticRenderFns } from "./i-tinvoice.vue?vue&type=template&id=94d948ce&"
import script from "./i-tinvoice.vue?vue&type=script&lang=js&"
export * from "./i-tinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports